'use client';

import { ApplicationSourceSurfaceSettingsRow } from '@terra/ui-design-system';
import { useExternalNetworkSurfaceDetail } from '../../../hooks/api/useSurfaceSettings';
import { useOpenWebAppPage } from '../../../hooks/useOpenWebAppPage';
import { buildSourceSurfaceWebPath } from './sourceSurfaceWebPath';

type TargetSourceSurfaceSettingsRowProps = {
  applicationId: string;
  sourceSurfaceId: string;
};

export function TargetSourceSurfaceSettingsRow({
  applicationId,
  sourceSurfaceId,
}: TargetSourceSurfaceSettingsRowProps) {
  const openWebAppPage = useOpenWebAppPage();
  const { data: surface } = useExternalNetworkSurfaceDetail(sourceSurfaceId);

  return (
    <ApplicationSourceSurfaceSettingsRow
      surfaceName={surface?.name}
      onOpenSurface={() =>
        openWebAppPage(
          buildSourceSurfaceWebPath({
            surfaceId: sourceSurfaceId,
            applicationId,
          }),
        )
      }
    />
  );
}
